import { makeId, recognizeDeviceState } from "./helpers";
import Paho from "paho-mqtt";
import { useEffect } from "react";

var hostname = "assessn.mmaviot.com";
var port = 9999;
var user = "vertex";
var password = "TwZs5P4wJ6t85G8NtPQZ";
var topic_assess = "assess/device/";
var topic_control = "control/device/";
var reconnectTimeout = 1000;
var timeout = 2000;
const ERROR_HOST_DISCONNECTED = "اتصال با سرور قطع شد!";
const ERROR_HOST_UNREACHABLE =
  "اتصال با سرور مقدور نیست برادر! آیا به اینترنت وصل هستید؟!";
const SUCCESS_HOST_CONNECTED = "اتصال با سرور برقرار گردید!";
const ALERT_HOST_CONNECTING = "در حال اتصال با سرور!";
const client = new Paho.Client(hostname, Number(port), makeId(9));

export const mqttClient = () => {
  const client = new Paho.Client(hostname, Number(port), makeId(9));
  return client;
};

function MqttConnection({ serials }) {
  let options = {
    timeout: 3000,
    mqttVersion: 3,
    onSuccess: onSuccess,
    onFailure: onFailure,
    userName: user,
    password: password,
    useSSL: true,
    keepAliveInterval: 500,
    reconnect: true,
  };
  var connected = false;

  useEffect(() => {
    client.onConnectionLost = onConnectionLost;
    client.onMessageArrived = onMessageArrived;
    client.connect(options);
    serials.map((v) => {
      setTimeout(() => {
        if (client) {
          var message = new Paho.Message("F1");
          message.destinationName = topic_control + v;
          client.send(message);
        }
      }, 3000);
    });
  }, []);

  function onSuccess() {
    connected = true;
    console.log(SUCCESS_HOST_CONNECTED);
    serials.map((v) => {
      setTimeout(() => {
        if (!connected) {
          // console.log("Not connected to host: " + hostname);
        } else {
          client.subscribe(topic_assess + v);
          client.subscribe(topic_control + v);
        }
      }, timeout);
    });
  }

  function onFailure(e) {
    // console.log(
    //   ERROR_HOST_UNREACHABLE +
    //     " " +
    //     hostname +
    //     "Failed! " +
    //     e.invocationContext +
    //     " Code: " +
    //     e.errorCode +
    //     " Message: " +
    //     e.errorMessage
    // );
  }

  function onConnectionLost(responseObject) {
    connected = false;
    // console.log(
    //   "onConnectionLost: " +
    //     ERROR_HOST_DISCONNECTED +
    //     " " +
    //     responseObject.errorMessage
    // );
  }

  function onMessageArrived(message) {
    // console.log(
    //   "Message arrived: Topic=" +
    //     message.destinationName +
    //     ", Message=" +
    //     message.payloadString
    // );
  }

  const subscribe = () => {
    client.subscribe(topic_assess);
    var message = new Paho.Message("آنلاین");
    message.destinationName = topic_control + "SWR1034234";
    client.send(message);
  };

  return <div></div>;
}

export { MqttConnection };
